const mixin={
  methods:{
    errorHandler(res){
      res=res.code?res:res.data;
      let code=1;
      switch (true) {
        case res.code>=10001 && res.code<=10004:
          code=10004;
          break;
        default:
          code=res.code;
          break;
      }
      return typeof code =='string'?code:this.$t(code);
    },
    trimAll(str){
      if(typeof str !=='string')return str;
      return str.replace(/\s/g,'');
    },
    regEmail(email){
      const emailReg=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailReg.test(email);
    },
    timeCountdown(obj) { //obj包括timer、waitTime 、canGet
      const TIME_COUNT = 60; //默认倒计时秒数
      if (!obj.timer) {
          obj.waitTime = TIME_COUNT;
          obj.canGet = false;
          obj.timer = setInterval(() => {
           if (obj.waitTime>1 && obj.waitTime<=TIME_COUNT) {
              obj.waitTime--;
          }else{
              obj.canGet = true;
              clearInterval(obj.timer); //清空定时器
              obj.timer = null;
            }
          }, 1000)
      }
    return {
        timer: obj.timer,
        canGet: obj.canGet,
        waitTime: obj.waitTime
    }
   }
  }
}

export default mixin



// WEBPACK FOOTER //
// ./src/common/mixins/commonUtils.js